import { render, staticRenderFns } from "./DiagMarker.vue?vue&type=template&id=833732d6&"
import script from "./DiagMarker.vue?vue&type=script&lang=js&"
export * from "./DiagMarker.vue?vue&type=script&lang=js&"
import style0 from "./DiagMarker.vue?vue&type=style&index=0&id=833732d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
